import React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const ProjectFileListItem = (props) => {

    return (

        <div className="d-flex flex-row justify-content-between border-bottom p-2">
            <div className="d-flex flex-column align-items-start justify-content-center">
                <h7>{props.name}</h7>
                <p className="font-weight-light p-0 m-0">{props.note}</p>
                <small className="text-muted">Uploaded by {props.username} {props.date}</small>
            </div>

            <div className="d-flex flex-column align-items-start justify-content-around">
                <FontAwesomeIcon color="#83a6ed" icon="file-download"/>
                <FontAwesomeIcon color="#ff6961" icon="trash-alt"/>
            </div>
        </div>
    )

}

export default ProjectFileListItem